/**
 * EcgridPackageTestPage Store
 * Zustand store for managing sample data state
 */

import { create } from 'zustand';
import type { SampleDataResponse } from '@/application/queries/sampleData';

/**
 * Initial state values
 */
const initialState = {
  data: null as SampleDataResponse | null,
  loading: true,
  error: null as Error | null,
};

/**
 * Store state interface
 */
interface EcgridPackageTestState {
  // Data
  data: SampleDataResponse | null;
  loading: boolean;
  error: Error | null;

  // Actions
  setData: (data: SampleDataResponse) => void;
  setLoading: (loading: boolean) => void;
  setError: (error: Error | null) => void;
  reset: () => void;

  // For testing
  _reset: () => void;
}

/**
 * Zustand store for EcgridPackageTestPage
 */
export const useEcgridPackageTestStore = create<EcgridPackageTestState>((set) => ({
  // Initial state
  ...initialState,

  // Actions
  setData: (data) =>
    set({
      data,
      loading: false,
      error: null,
    }),

  setLoading: (loading) => set({ loading }),

  setError: (error) =>
    set({
      error,
      loading: false,
    }),

  reset: () =>
    set({
      ...initialState,
      loading: true,
    }),

  // Reset to initial state (for testing)
  _reset: () => set(initialState),
}));
